export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8888';
console.log('[API_BASE from .env]', process.env.REACT_APP_API_URL);